import React from "react";
import Typography from "@material-ui/core/Typography";

export default function NextGenUpgradeText() {
    return (
        <>
            <Typography gutterBottom>
                DIRT 5 supports the <b>FREE upgrade system for next-gen consoles</b>, so grab the
                game on Xbox One and PlayStation 4, and get the next-gen optimised version, free of
                charge.
            </Typography>
            <Typography gutterBottom>
                Discless consoles require a digital entitlement to upgrade.
            </Typography>
        </>
    );
}
